import React from 'react';
import { Link } from 'react-router-dom';
import { FileCheck, ArrowLeft, Download, Trash2, Lock, Eye } from 'lucide-react';
import './LegalPages.css';

const GDPR = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <Link to="/" className="back-link">
          <ArrowLeft size={20} />
          <span>Înapoi la Pagina Principală</span>
        </Link>

        <div className="legal-header">
          <FileCheck size={48} />
          <h1>Conformitate GDPR</h1>
          <p className="legal-updated">Ultima actualizare: 25 August 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Angajamentul Nostru GDPR</h2>
            <p>
              <strong>MULTIPOWER TOUR SRL</strong> este pe deplin angajată în respectarea
              Regulamentului General privind Protecția Datelor (GDPR - Regulamentul UE 2016/679)
              și în protecția drepturilor dumneavoastră fundamentale privind confidențialitatea.
            </p>
            <div className="company-info">
              <h3>Operator de Date:</h3>
              <ul>
                <li><strong>MULTIPOWER TOUR SRL</strong></li>
                <li>Str. Zefirului, Nr.19, Mun. Dorohoi, Jud. Botoșani, România</li>
                <li>Tel: +4-0740-824.224</li>
                <li>Email: multipowertour@yahoo.com</li>
                <li>Web: https://multipowertour.ro</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>2. Principiile GDPR pe Care le Respectăm</h2>
            <div className="gdpr-principles">
              <div className="principle-card">
                <h3>Legalitate și Transparență</h3>
                <p>Prelucrăm datele în mod legal, corect și transparent</p>
              </div>
              <div className="principle-card">
                <h3>Limitarea Scopului</h3>
                <p>Colectăm date doar pentru scopuri specifice și legitime</p>
              </div>
              <div className="principle-card">
                <h3>Minimizarea Datelor</h3>
                <p>Colectăm doar datele strict necesare</p>
              </div>
              <div className="principle-card">
                <h3>Acuratețe</h3>
                <p>Păstrăm datele actualizate și corecte</p>
              </div>
              <div className="principle-card">
                <h3>Limitarea Stocării</h3>
                <p>Păstrăm datele doar cât timp este necesar</p>
              </div>
              <div className="principle-card">
                <h3>Integritate și Confidențialitate</h3>
                <p>Protejăm datele împotriva accesului neautorizat</p>
              </div>
            </div>
          </section>

          <section className="legal-section">
            <h2>3. Drepturile Dumneavoastră GDPR</h2>
            <p>
              Ca persoană vizată, beneficiați de următoarele drepturi în conformitate cu GDPR:
            </p>

            <div className="rights-grid">
              <div className="right-card">
                <Eye size={32} />
                <h3>Dreptul de Acces (Art. 15)</h3>
                <p>
                  Puteți obține confirmarea că prelucrăm datele dumneavoastră și o copie a acestora,
                  inclusiv informații despre scopul prelucrării și categoriile de date.
                </p>
                <button className="action-button">Solicită Acces</button>
              </div>

              <div className="right-card">
                <Lock size={32} />
                <h3>Dreptul de Rectificare (Art. 16)</h3>
                <p>
                  Puteți solicita corectarea datelor inexacte sau completarea datelor incomplete.
                </p>
                <button className="action-button">Rectifică Datele</button>
              </div>

              <div className="right-card">
                <Trash2 size={32} />
                <h3>Dreptul de Ștergere (Art. 17)</h3>
                <p>
                  Puteți solicita ștergerea datelor în anumite circumstanțe ("dreptul de a fi uitat").
                </p>
                <button className="action-button">Șterge Datele</button>
              </div>

              <div className="right-card">
                <FileCheck size={32} />
                <h3>Dreptul de Restricționare (Art. 18)</h3>
                <p>
                  Puteți solicita restricționarea prelucrării în anumite situații specifice.
                </p>
                <button className="action-button">Restricționează</button>
              </div>

              <div className="right-card">
                <Download size={32} />
                <h3>Dreptul la Portabilitate (Art. 20)</h3>
                <p>
                  Puteți primi datele într-un format structurat pentru transfer la alt operator.
                </p>
                <button className="action-button">Exportă Datele</button>
              </div>

              <div className="right-card">
                <FileCheck size={32} />
                <h3>Dreptul de Opoziție (Art. 21)</h3>
                <p>
                  Puteți obiecta la prelucrarea datelor pentru marketing sau în baza interesului legitim.
                </p>
                <button className="action-button">Obiectează</button>
              </div>
            </div>
          </section>

          <section className="legal-section">
            <h2>4. Cum Exercitați Drepturile GDPR</h2>
            <h3>4.1 Prin Aplicație</h3>
            <p>
              Puteți accesa și gestiona majoritatea setărilor de confidențialitate direct din aplicația
              mobilă sau panoul de control web:
            </p>
            <ul>
              <li>Setări → Confidențialitate → Gestionare Date</li>
              <li>Vizualizare și editare date personale</li>
              <li>Export date (format JSON/CSV)</li>
              <li>Ștergere cont și date asociate</li>
            </ul>

            <h3>4.2 Prin Email</h3>
            <p>
              Trimiteți o solicitare la <a href="mailto:multipowertour@yahoo.com">multipowertour@yahoo.com</a>
              cu subiectul "Solicitare GDPR - [Tipul Dreptului]"
            </p>
            <p>
              Vă rugăm să includeți:
            </p>
            <ul>
              <li>Numele complet</li>
              <li>Adresa de email asociată contului</li>
              <li>Descrierea clară a solicitării</li>
              <li>Copie act de identitate (pentru verificare)</li>
            </ul>

            <h3>4.3 Termenele Noastre</h3>
            <ul>
              <li><strong>Răspuns inițial:</strong> În termen de 48 de ore</li>
              <li><strong>Rezolvare completă:</strong> Maximum 30 de zile</li>
              <li><strong>Cazuri complexe:</strong> Până la 60 de zile (cu notificare)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Temeiul Legal al Prelucrării</h2>
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Tip Date</th>
                  <th>Temei Legal</th>
                  <th>Articol GDPR</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Date de cont și autentificare</td>
                  <td>Executarea contractului</td>
                  <td>Art. 6(1)(b)</td>
                </tr>
                <tr>
                  <td>Date de plată și facturare</td>
                  <td>Executarea contractului + Obligație legală</td>
                  <td>Art. 6(1)(b) + Art. 6(1)(c)</td>
                </tr>
                <tr>
                  <td>Date de localizare GPS</td>
                  <td>Consimțământ explicit</td>
                  <td>Art. 6(1)(a)</td>
                </tr>
                <tr>
                  <td>Marketing și newsletter</td>
                  <td>Consimțământ explicit</td>
                  <td>Art. 6(1)(a)</td>
                </tr>
                <tr>
                  <td>Analiză și îmbunătățire servicii</td>
                  <td>Interes legitim</td>
                  <td>Art. 6(1)(f)</td>
                </tr>
                <tr>
                  <td>Arhivare facturi</td>
                  <td>Obligație legală fiscală</td>
                  <td>Art. 6(1)(c)</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section className="legal-section">
            <h2>6. Evaluarea Impactului asupra Protecției Datelor (DPIA)</h2>
            <p>
              Am efectuat o Evaluare a Impactului asupra Protecției Datelor pentru activitățile
              de prelucrare cu risc ridicat, în special:
            </p>
            <ul>
              <li>Colectarea și procesarea datelor de localizare în timp real</li>
              <li>Profilarea utilizatorilor pentru optimizarea rutelor</li>
              <li>Stocarea datelor de plată și tranzacții</li>
            </ul>
            <p>
              Concluziile DPIA confirmă că riscurile sunt gestionate corespunzător prin măsuri
              tehnice și organizatorice adecvate.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Transferuri Internaționale de Date</h2>
            <p>
              Datele dumneavoastră sunt stocate exclusiv pe servere situate în Uniunea Europeană
              (România și Germania), asigurând protecția conform GDPR.
            </p>
            <p>
              În cazul în care este necesar un transfer către țări din afara UE/SEE, ne asigurăm că:
            </p>
            <ul>
              <li>Destinatarul are o decizie de adecvare de la Comisia Europeană, SAU</li>
              <li>Sunt implementate Clauze Contractuale Standard (SCC), SAU</li>
              <li>Există garanții adecvate aprobate de autorități</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Măsuri de Securitate Tehnice și Organizatorice</h2>
            <h3>Măsuri Tehnice:</h3>
            <ul>
              <li>Criptare AES-256 pentru datele în repaus</li>
              <li>TLS 1.3 pentru datele în tranzit</li>
              <li>Autentificare cu doi factori (2FA) disponibilă</li>
              <li>Monitorizare 24/7 și detectare intruziuni</li>
              <li>Backup automatizat cu criptare</li>
              <li>Segregarea rețelelor și acces bazat pe roluri</li>
              <li>Testare de penetrare anuală</li>
            </ul>

            <h3>Măsuri Organizatorice:</h3>
            <ul>
              <li>Politici interne de protecție a datelor</li>
              <li>Instruire obligatorie GDPR pentru angajați</li>
              <li>Acorduri de confidențialitate cu toți angajații</li>
              <li>Proceduri de răspuns la incidente</li>
              <li>Auditări periodice de conformitate</li>
              <li>Contracte DPA cu toți procesatorii</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Încălcări ale Securității Datelor</h2>
            <p>
              În cazul unei încălcări a securității datelor personale care implică un risc pentru
              drepturile și libertățile dumneavoastră:
            </p>
            <ul>
              <li>Vom notifica ANSPDCP în maximum 72 de ore de la descoperire</li>
              <li>Vă vom informa direct dacă riscul este ridicat</li>
              <li>Vom lua măsuri imediate de remediere și limitare a impactului</li>
              <li>Vom documenta incidentul conform cerințelor Art. 33-34 GDPR</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>10. Protecția Datelor prin Design și Implicit</h2>
            <p>
              Aplicăm principiile "Privacy by Design" și "Privacy by Default":
            </p>
            <ul>
              <li>Setări de confidențialitate maxime activate implicit</li>
              <li>Minimizarea colectării de date din design</li>
              <li>Pseudonimizare și anonimizare unde este posibil</li>
              <li>Securitate încorporată în arhitectura sistemului</li>
              <li>Funcții de ștergere automată după perioade definite</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>11. Procesatori de Date și Subprocesatori</h2>
            <p>
              Colaborăm cu următorii procesatori de date, toți cu acorduri DPA conforme GDPR:
            </p>
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Procesator</th>
                  <th>Serviciu</th>
                  <th>Locație</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Amazon Web Services (AWS)</td>
                  <td>Hosting cloud și infrastructură</td>
                  <td>UE (Frankfurt, Germania)</td>
                </tr>
                <tr>
                  <td>Stripe</td>
                  <td>Procesare plăți</td>
                  <td>UE (Irlanda)</td>
                </tr>
                <tr>
                  <td>SendGrid</td>
                  <td>Servicii email</td>
                  <td>UE (SCC)</td>
                </tr>
                <tr>
                  <td>Google Analytics</td>
                  <td>Analiză web (anonimizată)</td>
                  <td>UE + SCC</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section className="legal-section">
            <h2>12. Plângeri la Autoritatea de Supraveghere</h2>
            <p>
              Dacă considerați că drepturile dumneavoastră GDPR au fost încălcate, aveți dreptul
              de a depune o plângere la autoritatea de supraveghere:
            </p>
            <div className="contact-box">
              <p><strong>Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</strong></p>
              <p>B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București, România</p>
              <p>Tel: +40 318 059 211 / Fax: +40 318 059 602</p>
              <p>Email: anspdcp@dataprotection.ro</p>
              <p>Web: www.dataprotection.ro</p>
            </div>
            <p>
              Cu toate acestea, vă încurajăm să ne contactați mai întâi pentru a rezolva orice
              problemă în mod amiabil.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Contact Responsabil Protecția Datelor</h2>
            <p>
              Pentru orice întrebări sau solicitări legate de GDPR și protecția datelor:
            </p>
            <div className="contact-box">
              <p><strong>MULTIPOWER TOUR SRL</strong></p>
              <p>Responsabil cu Protecția Datelor (DPO)</p>
              <p>Str. Zefirului, Nr.19, Mun. Dorohoi, Jud. Botoșani, România</p>
              <p>Telefon: <a href="tel:+40740824224">+4-0740-824.224</a></p>
              <p>Email: <a href="mailto:multipowertour@yahoo.com">multipowertour@yahoo.com</a></p>
              <p>Subiect: "Solicitare GDPR"</p>
              <p>Web: <a href="https://multipowertour.ro">https://multipowertour.ro</a></p>
            </div>
          </section>

          <div className="legal-footer">
            <p>
              <strong>Multipower Tour SRL</strong> este angajată în protejarea drepturilor dumneavoastră
              fundamentale de confidențialitate și în conformitatea deplină cu GDPR.
            </p>
          </div>
        </div>

        <div className="legal-navigation">
          <Link to="/termeni" className="legal-nav-link">
            ← Termeni și Condiții
          </Link>
          <Link to="/confidentialitate" className="legal-nav-link">
            ← Politica de Confidențialitate
          </Link>
          <Link to="/cookies" className="legal-nav-link">
            Politica Cookies →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GDPR;
